import { render, staticRenderFns } from "./RecallVehicles.vue?vue&type=template&id=ceb03a80&scoped=true&"
import script from "./RecallVehicles.vue?vue&type=script&lang=js&"
export * from "./RecallVehicles.vue?vue&type=script&lang=js&"
import style0 from "./RecallVehicles.vue?vue&type=style&index=0&id=ceb03a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb03a80",
  null
  
)

export default component.exports